import { render } from "./SideMenu.vue?vue&type=template&id=da4d9a38&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=da4d9a38&scoped=true&lang=css"

import exportComponent from "/app/frontend-danahealth/dsg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4d9a38"]])

export default __exports__